import { useMemo } from "react";

import { useFeature } from "byzantine";
import { useInstitution } from "byzantine/src/dbbl/businessLogic/entities";

type EntryPointLocation = "accounts_menu" | "balances_dropdown";

/** The institution's account opening entry points for `location` that this user can enter. */
const useAccountOpeningEntryPoints = (
  location: EntryPointLocation
): API.AOEntryPoint[] => {
  const institution = useInstitution();
  const { featureEnabled } = useFeature();
  const hasAoiob = featureEnabled("aoiob");
  const entryPoints =
    institution?.account_opening_entry_points_config?.[location];

  return useMemo(
    () =>
      (entryPoints ?? []).filter(
        (entryPoint) => hasAoiob || entryPoint.platform !== "deposits"
      ),
    [entryPoints, hasAoiob]
  );
};

export default useAccountOpeningEntryPoints;
